import * as DataModel from '../model/PigPenModel'
import * as PIXI from 'pixi.js'

export class PigPenController {
    model = null;

    constructor() {
        this.setupCipher();
    }

    setupCipher() {
        this.model = new DataModel.PigPenModel();

        this.model.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        let r = Math.floor(Math.random() * DataModel.PIGPEN_QUESTIONS.length)
        this.model.potentialAnswers = DataModel.PIGPEN_QUESTIONS[r]; // DataModel.PIGPEN_QUESTIONS[r].answer.split('|');
        this.model.cipherPhrase = DataModel.PIGPEN_QUESTIONS[r];
        // console.log('question: ' + this.model.cipherPhrase, 'Answer(s): ' + this.model.potentialAnswers);
    }

    showPhrase(container) {
        if (this.model.phraseDisplayObjects) {
            this.destroyPhraseView();
        }
        this.model.phraseDisplayObjects = [];
        let phraseSplit = this.model.cipherPhrase.toUpperCase().split(' ');
        let lineContainer = new PIXI.Container();
        this.model.phraseDisplayObjects.push(lineContainer);
        container.addChild(lineContainer);
        let lineY = 0;
        let letterX = 0;
        for (let i = 0; i < phraseSplit.length; i++) {
            let wordSplit = phraseSplit[i].split('');
            if (lineContainer.width + DataModel.SPACE_WIDTH + wordSplit.length * 46 > DataModel.MAX_LINE_WIDTH) {
                lineContainer.y = lineY;
                lineContainer.x = -lineContainer.width / 2;
                lineContainer = new PIXI.Container();
                this.model.phraseDisplayObjects.push(lineContainer);
                container.addChild(lineContainer);
                lineY += DataModel.LINE_HEIGHT;
                letterX = 0;
            }
            for (let j = 0; j < wordSplit.length; j++) {
                if (this.model.alphabet.indexOf(wordSplit[j]) >= 0) {
                    let newLetter = PIXI.Sprite.from(wordSplit[j] + '_.png');
                    newLetter.anchor.x = newLetter.anchor.y = 0;
                    newLetter.scale.x = newLetter.scale.y = 0.48;
                    newLetter.x = letterX;
                    lineContainer.addChild(newLetter);
                    letterX += newLetter.width + DataModel.LETTER_SPACING;
                }
            }
            letterX += DataModel.SPACE_WIDTH;
        }
        lineContainer.y = lineY;
        lineContainer.x = -lineContainer.width / 2;
    }

    destroyPhraseView() {
        if (this.model.phraseDisplayObjects) {
            for (let i = 0; i < this.model.phraseDisplayObjects.length; i++) {
                this.model.phraseDisplayObjects[i].parent.removeChild(this.model.phraseDisplayObjects[i]);
            }
            while (this.model.phraseDisplayObjects.length > 0) {
                let d = this.model.phraseDisplayObjects.pop();
                d.destroy();
            }
            this.model.phraseDisplayObjects = null;
        }
    }

    depunctuate(string) {
        let justLettersArray = string.toUpperCase().split('');
        let justLettersResult = [];
        for (let i = 0; i < justLettersArray.length; i++) {
            if (this.model.alphabet.indexOf(justLettersArray[i]) >= 0) {
                justLettersResult.push(justLettersArray[i]);
            }
        }
        justLettersResult = justLettersResult.join('');
        return justLettersResult;
    }

    checkAnswer(answer) {
        /*
        answer = answer.toUpperCase();
        for (let i = 0; i < this.model.potentialAnswers.length; i++) {
            if (answer === this.model.potentialAnswers[i].toUpperCase()) {
                return true;
            }
        }
        return false;
        */
        // ensure we ignore spaces and punctuation in our answers
        let justLettersAnswerArray = answer.toUpperCase().split('');
        let justLettersAnswer = [];
        for (let i = 0; i < justLettersAnswerArray.length; i++) {
            if (this.model.alphabet.indexOf(justLettersAnswerArray[i]) >= 0) {
                justLettersAnswer.push(justLettersAnswerArray[i]);
            }
        }
        justLettersAnswer = justLettersAnswer.join('');

        let justLettersCorrectAnswerArray = this.model.potentialAnswers.toUpperCase().split('');
        let justLettersCorrectAnswer = [];
        for (let i = 0; i < justLettersCorrectAnswerArray.length; i++) {
            if (this.model.alphabet.indexOf(justLettersCorrectAnswerArray[i]) >= 0) {
                justLettersCorrectAnswer.push(justLettersCorrectAnswerArray[i]);
            }
        }
        justLettersCorrectAnswer = justLettersCorrectAnswer.join('');

        if (justLettersAnswer === justLettersCorrectAnswer /*&& this.model.currentTestShift === this.model.cipherShift*/) {
            return true;
        }
        return false;
    }
}